export default __webpack_public_path__ + "static/media/group-7357.cde9d877.svg";